(function () {
  const STORAGE_KEY = 'wc_cookie_consent_v1';

  function setConsent(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (error) {}

    document.cookie = 'wc_cookie_consent=' + value + '; path=/; max-age=31536000; SameSite=Lax';
  }

  function getConsent() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  function initCookieBanner() {
    const banner = document.querySelector('[data-wc-cookie-banner]');
    if (!banner) return;

    const acceptButton = banner.querySelector('[data-wc-cookie-accept]');
    const declineButton = banner.querySelector('[data-wc-cookie-decline]');

    if (getConsent()) {
      banner.hidden = true;
      return;
    }

    window.setTimeout(function () {
      banner.hidden = false;
    }, 800);

    if (acceptButton) {
      acceptButton.addEventListener('click', function () {
        setConsent('accepted');
        banner.hidden = true;
      });
    }

    if (declineButton) {
      declineButton.addEventListener('click', function () {
        setConsent('declined');
        banner.hidden = true;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCookieBanner);
  } else {
    initCookieBanner();
  }
})();